import React, {
  FC, useRef, useState, useEffect,
} from 'react';
import { useNavigate } from 'react-router-dom';
import Mixpanel from 'mixpanel-browser';
import QuizHeader from '~/components/QuizHeader';
import ProgressBar from '~/components/ProgressBar';
import reviews from '~/core/constants/reviews';
import Review from '~/components/Review';
import PagerView from '~/components/PagerView';
import { NavigationPath, ScreenProps } from '~/core/dto/navigationDTO';

import './FinancialIQ.styles.css';
import Spacer from '~/components/Spacer';
import { ModalPublicMethods } from '~/core/dto/components/modalDTO';
import Modal from '~/components/Modal';

const FinancialIQ: FC<ScreenProps> = ( { type } ) => {

  const navigate = useNavigate();
  const routeName = `FinancialIQ-${type}`;
  const isAdult = type === 'adult';

  const [ analyzingDone, setAnalyzingDone ] = useState( false );
  const [ stopped, setStopped ] = useState( false );

  const modalRef = useRef<ModalPublicMethods>( null );

  const onDone = () => {

    setAnalyzingDone( true );

    if ( !isAdult ) {

      setTimeout( () => {

        setStopped( true );
        modalRef.current?.open();

      }, 1160 );

    }

  };

  const onModalHide = ( answer: boolean ) => {

    Mixpanel.track( routeName, { modalAnswer: answer ? 1 : 0 } );

    setStopped( false );

  };

  const onContinue = () => {

    Mixpanel.track( routeName, { state: 1 } );

    navigate( type === 'adult' ? NavigationPath.AdultEmail : NavigationPath.Email, { replace: true } );

  };

  useEffect( () => {

    Mixpanel.track( routeName, { state: 0 } );

  }, [] );

  return (
    <div className="container">
      <QuizHeader type={type} onlyTitle />
      <div className="scrollContainer smallContainer">
        <div className="flexColumn justifxSpaceBetween">
          <div>
            <Spacer size={16} />
            <h1 className="textCenter">{isAdult ? 'Ready to see your' : 'We are creating your'}</h1>
            <h1 className="textCenter primaryBroadbill">{isAdult ? 'financial IQ?' : 'child’s experience'}</h1>
            <Spacer size={48} />
            <div className="financialIQProgress">
              <ProgressBar duration={3000} title={isAdult ? 'Analyzing answers' : 'Setting goals'} onDone={onDone} />
              {analyzingDone && (
              <>
                <div className="financialIQLine" />
                <ProgressBar stopped={stopped} duration={3000} title={isAdult ? 'Setting up challenge' : 'Adapting learning areas'} onDone={onContinue} />
              </>
              )}
            </div>
          </div>
          <div className="reviewsContainer">
            <h2 className="financialIQReviewsTitle textCenter">Enjoyed by 20K+ people</h2>
            <Spacer size={16} />
            <PagerView>
              {reviews.map( ( { emoji, ...review }, index ) => <Review key={`review${String( index )}`} {...review} /> )}
            </PagerView>
          </div>
          <Spacer size={48} />
        </div>
      </div>
      <Modal ref={modalRef} onHide={onModalHide} title="Does your child normally finish what they start?" subtitle="To move forward, specify" />
    </div>
  );

};

export default FinancialIQ;
